import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { ApiService } from 'src/app/services/http/api.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TeamItem } from 'src/app/models/team.model';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-teams-item-form.component',
  templateUrl: './teams-item-form.component.html'
})
export class EquipaItemFormComponent implements OnInit {
  @Input() public idEquipa = 0;
  @ViewChild("container", { read: ViewContainerRef }) public container: ViewContainerRef | undefined;
  public gridData: TeamItem[] = [];
  public customMsgService: CustomMessagesService;
  public refEquipa: number = 0;
  constructor(
    public msgService: MessageService, 
    private api: ApiService, 
    private notificationService: NotificationService,
    public dialog: DialogRef
  ) {
    this.customMsgService = this.msgService as CustomMessagesService;
  }

  public ngOnInit(): void {
    this.load();
  }

  // Método para carregar os dados de artigos
  public load(): void {
    this.api.getRequest<BaseHttpResponse<TeamItem[]>>("Equipa/GetEquipaArtigos?refEquipa=" + this.idEquipa)
      .then((data) => {
        this.gridData = data.value;

        // Verifique se os dados têm uma refEquipa e armazene
        if (this.gridData.length > 0) {
          this.refEquipa = this.gridData[0]?.refEquipa;  // Assumindo que todos os artigos têm a mesma refEquipa
        }
      })
      .catch((err) => {
        console.error("Erro ao carregar dados:", err);
      });
  }

  // Método para manipular a mudança de estado do switch
  public onSwitchChange(dataItem: TeamItem): void {
    dataItem.autorizado = !dataItem.autorizado; // Alterna o estado de autorizado
  }

  public saveChanges(): void {
    const data = this.gridData; 
    // Enviar os dados para a API
    this.api.save<BaseHttpResult>('Equipa/SaveEquipaArtigos', data)
      .then(res => {
        if (res.ok) {
          this.notificationService.show({
            content: this.customMsgService.translate('registoGravadoComSucesso'),
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'bottom' },
            type: { style: 'success', icon: true },
            hideAfter: 2000
          });
          this.dialog.close();
        } else {
          console.error('Erro ao salvar os dados');
        }
      })
      .catch(err => {
        console.error('Erro ao salvar dados', err);
      });
  }
}